import { render, staticRenderFns } from "./SimpleAuthorCalendar.vue?vue&type=template&id=6dacc67c&"
import script from "./SimpleAuthorCalendar.vue?vue&type=script&lang=js&"
export * from "./SimpleAuthorCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SimpleAuthorCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports